import React from 'react';
import moment from 'moment';
import { TaskEvent } from './EventTypes/TaskEvent';
import { RiskEvent } from './EventTypes/RiskEvent';
import { CalendarEvent } from './EventTypes/CalendarEvent';
import { CommunicationEvent } from './EventTypes/CommunicationEvent';
import { EventSkeleton } from './EventSkeleton';
import { getTaskRedirection, getProjectRedirection } from './utils';
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export const EventsList = ({
  events,
  isLoading,
  isFetchingNew,
  dateRange
}) => {
  const history = useHistory();
  const eventsByDate = React.useMemo(() => {
    const grouped = {};
    
    events.forEach(eventData => {
      const event = eventData.event;
      let eventDate;
      
      if (eventData.type === 2) {
        // Task - use end/ start date
        eventDate = moment(event.endDate || event.startDate);
      } else if (eventData.type === 3 && event.dateImpact) {
        // Risk - use impact date
        eventDate = moment(event.dateImpact);
      } else if (eventData.type === 4 && event.startTime) {
        // Calendar Event - use start time
        eventDate = moment(event.startTime);
      } else if (eventData.type === 5 && event.startTime) {
        // Communication Event - use start time
        eventDate = moment(event.startTime);
      } else {
        return;
      }
      
      const dateKey = eventDate.format('YYYY-MM-DD');
      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }
      grouped[dateKey].push(eventData);
    });
    
    return grouped;
  }, [events]);

  const sortedDates = React.useMemo(() => {
    return Object.keys(eventsByDate).sort();
  }, [eventsByDate]);

  const handleRedirection = (eventData) => {
    let redirectUrl;
    console.log('Handling redirection for eventData:', eventData.event);
    const event = eventData.event;
    switch (eventData.type) {
      case 2:
        redirectUrl = getTaskRedirection(event?.scope?.id, event.id);
        break;
      case 3:
        redirectUrl = getProjectRedirection(event?.project?.id, 'risk', event.id);
        break;
      case 4:
        redirectUrl = `/meeting`;
        break;
      case 5:
        redirectUrl = getProjectRedirection(event?.project?.id, 'communicationplan', event.id);
        break;
      default:
        break;
    }
    if(redirectUrl)
      history.push(redirectUrl);
  };

  const renderEvent = (eventData) => {
    switch (eventData.type) {
      case 2:
        return <TaskEvent key={eventData.event.id} event={eventData.event} OnRedirect={()=> {handleRedirection(eventData)}} />;
      case 3:
        return <RiskEvent key={eventData.event.id} event={eventData.event} OnRedirect={()=> {handleRedirection(eventData)}}/>;
      case 4:
        return <CalendarEvent key={eventData.event.id} event={eventData.event} OnRedirect={()=> {handleRedirection(eventData)}}/>;
      case 5:
        return <CommunicationEvent key={eventData.event.id} event={eventData.event} OnRedirect={()=> {handleRedirection(eventData)}}/>;
      default:
        return null;
    }
  };

  if (isLoading && !events.length) {
    return (
      <div className="events-list">
        <div className="events-list__header">
          <h4 className="events-list__title">Events</h4>
        </div>
        <div className="events-list__content">
          {[...Array(3)].map((_, index) => (
            <EventSkeleton key={index} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="events-list">
      <div className="events-list__content">
        {sortedDates.length === 0 ? (
          <div className="events-list__empty">
            No events found for the selected date range.
          </div>
        ) : (
          sortedDates.map(dateKey => (
            <div key={dateKey} className="events-list__date-group">
              <h5 className="events-list__date-header">
                {moment(dateKey).format('dddd, MMMM D')}
              </h5>
              <div className="events-list__date-events">
                {isFetchingNew ? (
                  [...Array(eventsByDate[dateKey].length)].map((_, index) => (
                    <EventSkeleton key={index} />
                  ))
                ) : (
                  eventsByDate[dateKey].map(renderEvent)
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};